/* The add-to-cart "added" checkmark burst is identical on every button; inlining
   it per button bloats the initial DOM. Keep one copy in a <template> (layout)
   and clone it into a button before its added state shows, so the CSS transition
   animation still plays. Delegated at the document, so Section-Rendering
   re-renders are covered. */
(function () {
  'use strict';
  if (window.bqAtcAddedIcon) return;
  window.bqAtcAddedIcon = true;

  function fill(comp) {
    var slot = comp && comp.querySelector('.add-to-cart__added-icon[data-bq-added-slot]');
    if (!slot || slot.firstElementChild) return; // absent or already filled
    var tpl = document.getElementById('bq-atc-added-tpl');
    if (tpl && tpl.content) slot.appendChild(tpl.content.cloneNode(true));
  }
  function fillFrom(el) {
    var comp = el && el.closest && el.closest('add-to-cart-component');
    if (comp) fill(comp);
  }
  function onEvent(e) { fillFrom(e.target); }

  // Hover / focus / press on the button — fires before the add.
  document.addEventListener('pointerover', onEvent, { passive: true, capture: true });
  document.addEventListener('pointerdown', onEvent, { passive: true, capture: true });
  document.addEventListener('focusin', onEvent, true);

  // Implicit submit (Enter in a field, e.g. the quantity input) fires a synthetic
  // click on the button with no pointer/focus landing on it — fill first so the
  // checkmark still animates.
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var host = e.target && e.target.closest && e.target.closest('form, product-form-component');
    var comp = host && host.querySelector('add-to-cart-component');
    if (comp) fill(comp);
  }, true);

  // Safety net: any path that flips [data-added] without prior interaction
  // (programmatic add) still gets the checkmark (inserted at the flip, so static).
  if (window.MutationObserver) {
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var el = records[i].target;
        if (el.getAttribute && el.getAttribute('data-added') === 'true') fillFrom(el);
      }
    }).observe(document.documentElement, { subtree: true, attributes: true, attributeFilter: ['data-added'] });
  }
})();
